"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caramanico-terme": {
    "8bf22fc6": [{
      "hkey": "bd273bff",
      "slug": "caramanico-terme",
      "name": "Caramanico Terme",
      "primary": true,
      "skipSearch": false
    }],
    "canale": [{
      "hkey": "bd273bff",
      "slug": "caramanico-terme",
      "name": "Caramanico Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4912f532": [{
      "hkey": "8e549e94",
      "slug": "scagnane",
      "name": "Scagnane",
      "primary": true,
      "skipSearch": false
    }],
    "scagnane-di-sotto": [{
      "hkey": "8e549e94",
      "slug": "scagnane",
      "name": "Scagnane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caramanico-terme"
    }]
  }
};
exports["default"] = _default;